module.exports = __webpack_public_path__ + "img/drive_driver.d66f0219.svg";